var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagAe = function SvgFlagAe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "flag_ae_svg__a",
    width: 16,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag_ae_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5FBFF",
    fillRule: "evenodd",
    d: "M0 0h16v12H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5DAA22",
    fillRule: "evenodd",
    d: "M0 0v4h16V0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M0 8v4h16V8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E31C1C",
    d: "M0 0h5v12H0z"
  }))));
};
export default SvgFlagAe;